var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSeeDetailsAction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M10 11.25c-.689 0-1.25-.56-1.25-1.25 0-.689.561-1.25 1.25-1.25.69 0 1.25.561 1.25 1.25 0 .69-.56 1.25-1.25 1.25m0-4.166c-1.608 0-2.916 1.308-2.916 2.916 0 1.608 1.308 2.917 2.916 2.917 1.609 0 2.917-1.309 2.917-2.917 0-1.608-1.308-2.916-2.917-2.916m.184 7.08c-3.589.084-5.93-2.985-6.706-4.167.855-1.338 3.008-4.076 6.34-4.161 3.574-.091 5.928 2.986 6.705 4.168-.854 1.338-3.009 4.076-6.34 4.16m8.04-4.578c-.531-.927-3.468-5.572-8.448-5.416-4.607.117-7.286 4.175-7.997 5.416-.148.256-.148.572 0 .829.524.914 3.357 5.418 8.243 5.418.068 0 .137 0 .205-.002 4.606-.118 7.286-4.175 7.998-5.416.146-.257.146-.573 0-.83",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSeeDetailsAction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/see_details_action.5aa1873c.svg";
export { ForwardRef as ReactComponent };